"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _ExtendedFieldDescription = _interopRequireDefault(require("./ExtendedFieldDescription"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ExtendedFieldInline(_ref) {
  var item = _ref.item,
    catalogs = _ref.catalogs,
    disabled = _ref.disabled,
    showPopup = _ref.showPopup;
  var value = (0, _react.useMemo)(function () {
    var _a, _b, _c, _d;
    if (!item.value) return '---';
    if (item.field.type === 'CATALOG' && item.field.reference) {
      var values = (_b = (_a = catalogs === null || catalogs === void 0 ? void 0 : catalogs.find(function (el) {
        return el.id === item.field.reference;
      })) === null || _a === void 0 ? void 0 : _a.values) !== null && _b !== void 0 ? _b : [];
      return (_d = (_c = values.find(function (el) {
        return el.external_id === item.value;
      })) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : item.value;
    }
    if (item.field.type === 'FILE') {
      var raw = "".concat(item.value);
      var index = raw.lastIndexOf('/');
      return raw.substring(index + 1);
    }
    return item.value;
  }, [item, catalogs]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    key: item.id,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "flex-end",
    alignContent: "center",
    alignItems: "center",
    columnSpacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    size: "small",
    color: "primary",
    onClick: showPopup,
    disabled: disabled && item.field.type !== 'FILE'
  }, item.field.type === 'FILE' && disabled ? /*#__PURE__*/_react["default"].createElement(_commons.FileIcon, null) : /*#__PURE__*/_react["default"].createElement(_commons.EditIcon, null))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2"
  }, value)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    color: "textSecondary",
    gutterBottom: !!item.field.description
  }, "".concat(item.field.name).concat(item.field.required ? ' *' : '')), item.field.description !== undefined && /*#__PURE__*/_react["default"].createElement(_ExtendedFieldDescription["default"], {
    description: item.field.description
  }))))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ExtendedFieldInline);